import { IConfigData } from '@df/catalog/config/config.interfaces';
import { app } from '@df/core/app';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

export namespace NListingLabel {
    export const CONFIG_ID = 'listing-label';

    export interface IModelData extends IConfigData<IConfigContent> {}

    export interface IConfigContent {
        enabled: boolean;
        textColor: string | null;
        bgColor: string | null;
        labels: (Partial<ILabelStyle> & { value: number })[];
        labelsCustomer: (Partial<ILabelStyle> & { value: number })[];
    }

    export interface ILabelStyle {
        textColor: string | null;
        bgColor: string | null;
    }
}

ICmsContentService.registerConfig({
    id: NListingLabel.CONFIG_ID,
    name: 'Listing labels',
    fields: [
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'enabled',
            title: 'Enabled',
            default: true
        },
        {
            type: NICmsContentField.EFieldType.colorPicker,
            key: 'textColor',
            title: 'Text color',
            default: '#333333'
        },
        {
            type: NICmsContentField.EFieldType.colorPicker,
            key: 'bgColor',
            title: 'Background color',
            default: '#f7f7f7'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'labels',
            title: 'Labels',
            required: true,
            itemName: 'label',
            itemNameField: 'value',
            fields: [
                <NICmsContentField.IChoiceField>{
                    key: 'value',
                    required: true,
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Option',
                    options: () =>
                        app.resources.attribute
                            .get('listing_label')
                            ?.data?.options?.map(option => ({ key: option.value, title: option.label })) || []
                },
                {
                    type: NICmsContentField.EFieldType.colorPicker,
                    key: 'textColor',
                    title: 'Text color'
                },
                {
                    type: NICmsContentField.EFieldType.colorPicker,
                    key: 'bgColor',
                    title: 'Background color'
                }
            ]
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'labelsCustomer',
            title: 'Labels Customer',
            itemName: 'label',
            itemNameField: 'value',
            fields: [
                <NICmsContentField.IChoiceField>{
                    key: 'value',
                    required: true,
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Option',
                    options: () =>
                        app.resources.attribute
                            .get('listing_label_customer')
                            ?.data?.options?.map(option => ({ key: option.value, title: option.label })) || []
                },
                {
                    type: NICmsContentField.EFieldType.colorPicker,
                    key: 'textColor',
                    title: 'Text color'
                },
                {
                    type: NICmsContentField.EFieldType.colorPicker,
                    key: 'bgColor',
                    title: 'Background color'
                }
            ]
        }
    ]
});
